module.exports = __webpack_public_path__ + "static/media/Snow.492c3271.jpg";